import FABButtonLocation from '../enums/FABButtonLocation';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logCustomRouteButtonClickedParams = {
  custom_route_id?: number;
  location: FABButtonLocation;
  route_loaded?: boolean;
  trail_id?: number;
};

/**
 * User clicks the build custom route button in navigator or on trail details page
 * @param params - Attributes to log with the amplitude event
 * @param params.custom_route_id - the custom route id of the loaded route (null if no route loaded)
 * @param params.location - The location of the Custom Route Button when it was clicked
 * @param params.route_loaded - TRUE if a route was loaded when a user clicks the custom route button
 * @param params.trail_id - the trail id of the loaded route (null if no route loaded)
 */
const logCustomRouteButtonClicked = (
  { custom_route_id, location, route_loaded, trail_id }: logCustomRouteButtonClickedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'custom route button clicked',
    { 'custom route id': custom_route_id, location, 'route loaded': route_loaded, 'trail id': trail_id },
    callback
  );
};

export default logCustomRouteButtonClicked;
